import { GetdatafirebaseService } from './../../services/getdatafirebase.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import axios from 'axios';
//import * as XLSX from 'xlsx';
@Component({
  selector: 'app-infor-qcard',
  templateUrl: './infor-qcard.component.html',
  styleUrls: ['./infor-qcard.component.css']
})
export class InforQcardComponent implements OnInit {
  Formdata: UntypedFormGroup;
  year: any;
  constructor(private getfirebase: GetdatafirebaseService) {
    this.Formdata = new UntypedFormGroup({
      fmdata: new UntypedFormControl(),
      st_type: new UntypedFormControl(),
    });
    this.getfirebase.getYear().then((year: any) => { this.year = year.slice(3); });
  }
  yearselect = { year: '2526', year_th: '68/69' }
  ngOnInit(): void {
    this.change_search(1);
  }
  txtSearch = '';

  textshow1: string;
  textsearch: string;
  type_s = 1;
  change_search(data: number) {
    this.type_s = data;
    if (data == 1) {
      this.textsearch = '[fmcode]';
      this.textshow1 = 'โควตาชาวไร่(5-6ตัว)'
    }
    else if (data == 2) {
      this.textsearch = '[groupCode]'
      this.textshow1 = 'เลขกลุ่มตัด'
    }
    else if (data == 3) {
      this.textsearch = '[REGTRUCK]'
      this.textshow1 = 'เลขทะบียนรถ'
    }
    // console.log('change_search',data,this.textshow1,this.textsearch)
  }
  DataBZL: number = null;
  DataByZone: any;
  data_in = [];
  Loaddatabyzone() {
    let data = this.txtSearch;//(this.Formdata.get('fmdata').value).trim();
    if (data == '' || data == undefined) {
      alert('กรุณากรอก ข้อความที่จะค้นหา')
    }
    /*else if (year == '' ||year == undefined)
    {   alert('กรุณาระบุปี') }*/
    else {
      /*if (this.type_s == 3) { data = `LIKE'%${data}%'` }
      else { data = `='${data}'` }*/
      data = `='${data}'`
      let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=dbQBRD.dbo.[v_qcard${this.yearselect.year}]&w=${this.textsearch}${data}`;
      axios.get(url).then(res => {
        let data = res.data;
        data.sort((b, a) => (a.ref_doc1 > b.ref_doc1) ? 1 : (a.ref_doc1 == b.ref_doc1) ? ((a.q_id > b.q_id) ? 1 : -1) : -1);

        this.data_in = data
        this.DataByZone = data
        this.DataBZL = data.length;
        this.Selectbytype();
      }).catch(err => {
        throw (err)
      })
    }

  }
  filterbytype: number = null;
  Selectbytype() {
    let sdata = this.filterbytype//this.Formdata.get('st_type').value;
    if (sdata == null) {
      this.DataByZone = this.data_in;
    }
    else if (sdata >= 0) {
      this.DataByZone = this.data_in.filter((el: any) => el.print_q == sdata);
    }
    this.DataBZL = this.DataByZone.length;
    /*console.log('sdata',sdata);
    console.log('DataBZL',this.DataByZone);*/
  }
  THtoLocalstring(date: any) {
    if (!date) { return ''; }
    const date1 = new Date(date);
    let options: any = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      timeZone: 'UTC',
    };
    return date1.toLocaleString('th-TH', options);
  }

}
